













































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import Chart, { ChartOptions } from "chart.js";
import { jsPDF } from "jspdf";
import { BPopover } from "bootstrap-vue";
import { MessageSummaryReportFilter } from "@/store/modules/types";

import { DateTimeSpan } from "@/store/modules/enums";
import DateRangePopover from "@/components/DateRangePopover.vue";
import moment from "moment";
import VueSelect from "vue-select";
import { getDate } from '@/services/timezone';

@Component({
  components: { Header, EntityTabs, BPopover, DateRangePopover, VueSelect },
  computed: mapState("auth", ["user"])
  ,
})
export default class Summary extends Vue {
  reportFilter = this.defaultFilter();
  user!: any;
  summary: Array<any> = [];
  crSummary: Array<any> = [];
  total: number = 0;
  lastUpdate: any = null;
  getDate = getDate;

  //
  summaryByEntity: Array<any> = [];
  summaryByReason: Array<any> = [];
  summaryByStatus: Array<any> = [];

  //chart
  chartPriorities: Array<any> = [];
  chart: any = {
    DURATION: null,
    DURATION_PRODUCT: null,
    TOTAL_COUNT_PRODUCT: null,
    TOTAL_COUNT_MESSAGE_TYPE: null,
    TOTAL_COUNT_SUMMARY: null
  };

  types: Array<any> = [{ "id": "SMS" },
                       {"id": "WHATSAPP"},
                       { "id": "VOICE" }];

  @Watch("reportFilter", { deep: true })
  onFilterChanged() {
    if (!this.reportFilter.entity) {
      this.clearSearch("select-entity")
    }

    if (!this.reportFilter.type) {
      this.clearSearch("select-type")
    }

    this.getSummary();
  }


  defaultFilter(): MessageSummaryReportFilter {
    return {
      entity: null,
      type: "",
      date: {
        from: this.$moment().startOf('month').toString(),
        to: this.$moment().endOf('month').toString(),
      },
    };
  }

  setDateFilter(timeSpan: DateTimeSpan, from: string, to: string) {
    if (from) {
      this.reportFilter.date.from = from;
      this.reportFilter.date.to = to;
    } else {
      this.reportFilter.date.from = this.$moment().startOf('month').toString();
      this.reportFilter.date.to = this.$moment().endOf('month').toString();
    }

  }

  async getSummary() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      this.summary = await this.$store.dispatch("schedule/getMessageSummaryReport", this.reportFilter);
      this.crSummary = await this.$store.dispatch("schedule/getCrMessageSummaryReport", this.reportFilter);

      // SET CHARTS
      this.setCharts();
      this.setCrCharts();
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  async setCharts() {
    var summaryEntity: any = [];
    var summaryMessageType: any = [];
    var summaryProduct: any = [];
    var summaryDuration: any = [];
    var summaryDurationByProduct: any = [];
    this.total = 0;
    var maxRecord = 10;

    this.lastUpdate = this.summary.length? getDate(this.summary[0].lastUpdate) : null;

    //chart destroy
    for (const c in this.chart) {
      if (this.chart[c]) {
        this.chart[c].destroy();
      }
    }


    if (this.chart.PDF_CONTACT_NO_CONTACT) {
      this.chart.PDF_CONTACT_NO_CONTACT.destroy();
    }
    /*var summaryMessage = this.summary
      .map((s) => s.entityName)
      .filter((v, i, a) => a.indexOf(v) === i);*/

    var entities = this.summary
      .map((s) => s.entityName)
      .filter((v, i, a) => a.indexOf(v) === i);


    for (const entity of entities) {
      var count: any = this.summary
        .filter((item) => item.entityName === entity)
        .map((i) => i.count)
        .reduce((accumulator, value) => accumulator + value, 0);

      summaryEntity.push(count);
    }

    // sort Total Count
    var summaryEntityObj = entities.map(function (d, i) {
      return {
        label: d,
        data: summaryEntity[i] || 0
      };
    });

    var sortedSummaryEntityObj = summaryEntityObj.sort((a, b) => {
      return (b.data > a.data) ? 1 : -1;
    });

    entities = [];
    summaryEntity = [];

    sortedSummaryEntityObj.forEach(function (d) {
      entities.push(d.label);
      summaryEntity.push(d.data);
    });

    //

    //MESSAGE TYPE
    var messageTypes = this.summary
      .map((s) => s.messageType)
      .filter((v, i, a) => a.indexOf(v) === i);


    for (const type of messageTypes) {
      count = this.summary
        .filter((item) => item.messageType === type)
        .map((i) => i.count)
        .reduce((accumulator, value) => accumulator + value, 0);

      summaryMessageType.push(count);
    }

    //TOTAL COUNT BY PRODUCT

    var products = this.summary
      .map((s) => s.productName)
      .filter((v, i, a) => a.indexOf(v) === i);


    for (const product of products) {
      count = this.summary
        .filter((item) => item.productName === product)
        .map((i) => i.count)
        .reduce((accumulator, value) => accumulator + value, 0);

      summaryProduct.push(count);
    }


    //DURATION


    for (const entity of entities) {
      count = this.summary
        .filter((item) => item.entityName === entity && item.messageType === "VOICE")
        .map((i) => i.duration)
        .reduce((accumulator, value) => accumulator + value, 0);

      summaryDuration.push(count);
    }

    // sort Duration
    var summaryDurationObj = entities.map(function (d, i) {
      return {
        label: d,
        data: summaryDuration[i] || 0
      };
    });

    var sortedSummaryDurationObj = summaryDurationObj.sort((a, b) => {
      return (b.data > a.data) ? 1 : -1;
    });

    var durationEntities: any = [];
    summaryDuration = [];

    sortedSummaryDurationObj.forEach(function (d) {
      durationEntities.push(d.label);
      summaryDuration.push(d.data);
    });

    //


    //DURATION BY PRODUCT

    for (const product of products) {
      count = this.summary
        .filter((item) => item.productName === product && item.messageType === "VOICE")
        .map((i) => i.duration)
        .reduce((accumulator, value) => accumulator + value, 0);

      summaryDurationByProduct.push(count);
    }

    const backgroundColor = [
      "#00b0d3",
      "#2541b2",
      "#007991",
      "#217cc8",
      "#03256c",
      "#217cc8",
      "FF1493",
      "#228B22",
      "#ADFF2F",
      "#FFA07A",
      "#800080",
      "#FFFF00"

    ];

    //set chart
    let canvas: any = document.getElementById("TOTAL_COUNT_SUMMARY");
    let context = canvas.getContext("2d");
    var type = "doughnut";

    this.chart.TOTAL_COUNT_SUMMARY = new Chart(context, {
      type,
      data: {
        labels: entities.slice(0, maxRecord),
        datasets: [
          {
            label: "",
            data: summaryEntity.slice(0, maxRecord), //[300, 50, 100],
            backgroundColor,
            //hoverOffset: 4
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    //types
    canvas = document.getElementById("TOTAL_COUNT_MESSAGE_TYPE");
    context = canvas.getContext("2d");

    this.chart.TOTAL_COUNT_MESSAGE_TYPE = new Chart(context, {
      type,
      data: {
        labels: messageTypes,
        datasets: [
          {
            label: "",
            data: summaryMessageType, //[300, 50, 100],
            backgroundColor,
            //hoverOffset: 4
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    //products
    canvas = document.getElementById("TOTAL_COUNT_PRODUCT");
    context = canvas.getContext("2d");

    this.chart.TOTAL_COUNT_PRODUCT = new Chart(context, {
      type,
      data: {
        labels: products,
        datasets: [
          {
            label: "",
            data: summaryProduct,
            backgroundColor,
            //hoverOffset: 4
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    //DURATION
    canvas = document.getElementById("DURATION");
    context = canvas.getContext("2d");

    this.chart.DURATION = new Chart(context, {
      type,
      data: {
        labels: durationEntities.slice(0, maxRecord),
        datasets: [
          {
            label: "",
            data: summaryDuration.slice(0, maxRecord),
            backgroundColor,
            //hoverOffset: 4
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    //DURATION BY PRODUCT
    canvas = document.getElementById("DURATION_PRODUCT");
    context = canvas.getContext("2d");

    this.chart.DURATION_PRODUCT = new Chart(context, {
      type,
      data: {
        labels: products,
        datasets: [
          {
            label: "",
            data: summaryDurationByProduct,
            backgroundColor,
            //hoverOffset: 4
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    //summary by Entity

    this.summaryByEntity = [];

    var objEntity = {
      entityName: null,
      totalSMS: 0,
      totalWhatsApp: 0,
      totalVoice: 0,
      duration: 0
    }

    for (const entity of entities) {
      count = this.summary
        .filter((item) => item.entityName === entity && item.messageType === "SMS")
        .map((i) => i.count)
        .reduce((accumulator, value) => accumulator + value, 0);

      objEntity.entityName = entity;
      objEntity.totalSMS = count;

      count = this.summary
        .filter((item) => item.entityName === entity && item.messageType === "WHATSAPP")
        .map((i) => i.count)
        .reduce((accumulator, value) => accumulator + value, 0);

      objEntity.entityName = entity;
      objEntity.totalWhatsApp = count;

      count = this.summary
        .filter((item) => item.entityName === entity && item.messageType === "VOICE")
        .map((i) => i.count)
        .reduce((accumulator, value) => accumulator + value, 0);

      objEntity.totalVoice = count;

      count = this.summary
        .filter((item) => item.entityName === entity && item.messageType === "VOICE")
        .map((i) => i.duration)
        .reduce((accumulator, value) => accumulator + value, 0);

      objEntity.duration = count;

      this.total = this.total + objEntity.totalSMS + objEntity.totalWhatsApp + objEntity.totalVoice;
      this.summaryByEntity.push(Object.assign({}, objEntity));

    }

  }

  async setCrCharts() {

    var entities = this.crSummary
      .map((s) => s.entityName)
      .filter((v, i, a) => a.indexOf(v) === i);



    this.summaryByReason = [];



    for (const entity of entities) {

      var objReason = {
        reason: null,
        entityName: null,
        totalSMS: 0,
        totalVoice: 0,
        totalEmail: 0,
        totalFax: 0,
        totalWeb: 0,
        total: 0,
        show: false,
        border: false
      }

      var reasons = this.crSummary
        .filter(s => s.entityName === entity)
        .map((s) => s.reason)
        .filter((v, i, a) => a.indexOf(v) === i);

      var show = true;

      for (const [index, reason] of reasons.entries()) {
        var count = this.crSummary
          .filter((item) => item.entityName === entity && item.reason === reason && item.messageType === "SMS")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objReason.reason = reason;
        objReason.entityName = entity;
        objReason.totalSMS = count;


        count = this.crSummary
          .filter((item) => item.entityName === entity && item.reason === reason && item.messageType === "VOICE")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objReason.totalVoice = count;

        count = this.crSummary
          .filter((item) => item.entityName === entity && item.reason === reason && item.messageType === "EMAIL")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objReason.totalEmail = count;

        count = this.crSummary
          .filter((item) => item.entityName === entity && item.reason === reason && item.messageType === "FAX")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objReason.totalFax = count;

        count = this.crSummary
          .filter((item) => item.entityName === entity && item.reason === reason && item.messageType === "WEB")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objReason.totalWeb = count;

        //total
        objReason.total = objReason.totalSMS + objReason.totalVoice + objReason.totalEmail + objReason.totalFax + objReason.totalWeb;

        objReason.show = show;
        if (index == reasons.length - 1) {
          objReason.border = true;
        }

        this.summaryByReason.push(Object.assign({}, objReason));
        show = false;


      }

    }

    //conversation by Status
    this.summaryByStatus = [];

    for (const entity of entities) {

      var objStatus = {
        status: null,
        entityName: null,
        totalSMS: 0,
        totalVoice: 0,
        totalEmail: 0,
        totalFax: 0,
        totalWeb: 0,
        total: 0,
        show: false,
        border: false
      }

      var statuses = this.crSummary
        .filter(s => s.entityName === entity)
        .map((s) => s.status)
        .filter((v, i, a) => a.indexOf(v) === i);

      show = true;

      for (const [index, status] of statuses.entries()) {

        count = this.crSummary
          .filter((item) => item.entityName === entity && item.status === status && item.messageType === "SMS")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objStatus.status = status;
        objStatus.entityName = entity;
        objStatus.totalSMS = count;


        count = this.crSummary
          .filter((item) => item.entityName === entity && item.status === status && item.messageType === "VOICE")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objStatus.totalVoice = count;

        count = this.crSummary
          .filter((item) => item.entityName === entity && item.status === status && item.messageType === "EMAIL")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objStatus.totalEmail = count;

        count = this.crSummary
          .filter((item) => item.entityName === entity && item.status === status && item.messageType === "FAX")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objStatus.totalFax = count;

        count = this.crSummary
          .filter((item) => item.entityName === entity && item.status === status && item.messageType === "WEB")
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

        objStatus.totalWeb = count;


        //total

        objStatus.total = objStatus.totalSMS + objStatus.totalVoice + objStatus.totalEmail + objStatus.totalFax + objStatus.totalWeb;

        /*count = this.crSummary
          .filter((item) => item.entityName === entity && item.status === status)
          .map((i) => i.count)
          .reduce((accumulator, value) => accumulator + value, 0);

       
        objStatus.total = count;*/

        objStatus.show = show;
        if (index == statuses.length - 1) {
          objStatus.border = true;
          //console.log('index: ' + index);
        }

        //this.total = this.total + objEntity.totalSMS + objEntity.totalVoice;
        this.summaryByStatus.push(Object.assign({}, objStatus));
        show = false;

      }



    }



    //end conversation by Status


  }

  async exportPDF() {
    this.$store.commit("main/SET_LOADING", true);

    var el = document.getElementById("report")!;
    const scale = 0.8;
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: [el.offsetWidth * scale, el.offsetHeight * scale + 50], //10
      //format: [2114 * scale, 2314 * scale + 200]
    });

    doc.html(el, {
      html2canvas: {
        scale,
      },
      //HTMLOptions:options,
      callback: (doc) => {
        doc.save(
          "summary_report_" + this.$moment().format("MMDDYYYY_hhmmA") + ".pdf"
        );
        this.$store.commit("main/SET_LOADING", false);
      },
      x: 0,
      y: 0,
    });
  }

  /*async exportExcel(detailed) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { campaignId } = this;
      const mime = "application/octet-stream";
      const data = await this.$store.dispatch("gaps/getSummaryExel", {
        campaignId,
        detailed,
      });
      const blob = new Blob([data], { type: mime });
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      const anchor = document.createElement("a");
      //anchor.download = `summary_report_${timestamp}.xlsx`;
      anchor.download = detailed == true ? `summary_report_datailed_${timestamp}.xlsx` : `summary_report_${timestamp}.xlsx`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [mime, anchor.download, anchor.href].join(
        ":"
      );
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }*/

  /*get getEntity() {
    return this.$store.state.auth.user.entities.filter(
      (e) => e.id == this.$store.state.auth.entityId
    )[0];
  }

  get getCampaign() {
    return this.campaignId
      ? this.$store.state.gaps.campaigns.filter(
        (c) => c.id == this.campaignId
      )[0]
      : { name: "All" };
  }*/

  totalByType(type) {

    var total = 0;

    switch (type) {
      case "SMS":
        total = this.summaryByStatus.map((i) => i.totalSMS)
          .reduce((accumulator, value) => accumulator + value, 0);
        break;
      case "VOICE":
        total = this.summaryByStatus.map((i) => i.totalVoice)
          .reduce((accumulator, value) => accumulator + value, 0);
        break;
        case "EMAIL":
        total = this.summaryByStatus.map((i) => i.totalEmail)
          .reduce((accumulator, value) => accumulator + value, 0);
        break;
      case "FAX":
        total = this.summaryByStatus.map((i) => i.totalFax)
          .reduce((accumulator, value) => accumulator + value, 0);
        break;
      case "WEB":
        total = this.summaryByStatus.map((i) => i.totalWeb)
          .reduce((accumulator, value) => accumulator + value, 0);
        break;
      default:
      total = this.summaryByStatus.map((i) => i.total)
          .reduce((accumulator, value) => accumulator + value, 0);
        break;
    }


    return total
  }

  clearSearch(refs) {
    console.log(refs);
    this.$refs[refs]["search"] = "";
  }

  close(id) {
    this.$root.$emit("bv::hide::popover", id);
  }

  mounted() {
    this.getSummary();
  }
}
